"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SELLERS_JSON_INVALIDATION_SUBJECT = void 0;
exports.SELLERS_JSON_INVALIDATION_SUBJECT = "sellers-json.invalidate.v1";
